import { gql } from '@apollo/client';

export const register = gql`
  mutation Register(
    $input: SignUpInput!
  ) {
    register (
      input: $input
    ) {
      _id
      _ref
      _createdBy
      _createdOn
      _updatedBy
      _updatedOn
    }
  }
`

export const login = gql`
  query Login(
    $email: String!,
    $password: String!
  ) {
    login (
      email: $email
      password: $password
    ) {
      authToken: accessToken
      accessTokenExpiredOn
      lastAccessOn
      user_id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/services/user.js